import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ChartScatterIcon = function ChartScatterIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_6978_13)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 17C0 16.4477 0.447715 16 1 16H17C17.5523 16 18 16.4477 18 17C18 17.5523 17.5523 18 17 18H1C0.447715 18 0 17.5523 0 17Z",
        fill: "#12131A"
      }), /*#__PURE__*/_jsx("circle", {
        cx: "3",
        cy: "13",
        r: "1",
        fill: "#8C8C8C"
      }), /*#__PURE__*/_jsx("circle", {
        cx: "7",
        cy: "4",
        r: "1",
        fill: "#12131A"
      }), /*#__PURE__*/_jsx("circle", {
        cx: "7",
        cy: "9",
        r: "1",
        fill: "#12131A"
      }), /*#__PURE__*/_jsx("circle", {
        cx: "11",
        cy: "6",
        r: "1",
        fill: "#8C8C8C"
      }), /*#__PURE__*/_jsx("circle", {
        cx: "4",
        cy: "6",
        r: "1",
        fill: "#8C8C8C"
      }), /*#__PURE__*/_jsx("circle", {
        cx: "11",
        cy: "1",
        r: "1",
        fill: "#8C8C8C"
      }), /*#__PURE__*/_jsx("circle", {
        cx: "11",
        cy: "11",
        r: "1",
        fill: "#12131A"
      }), /*#__PURE__*/_jsx("circle", {
        cx: "15",
        cy: "8",
        r: "1",
        fill: "#12131A"
      }), /*#__PURE__*/_jsx("circle", {
        cx: "15",
        cy: "2",
        r: "1",
        fill: "#12131A"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_6978_13",
        children: /*#__PURE__*/_jsx("rect", {
          width: "18",
          height: "18",
          fill: "white"
        })
      })
    })]
  }));
};

ChartScatterIcon.defaultProps = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var ChartBubbleIcon = function ChartBubbleIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6 11C7.65685 11 9 9.65685 9 8C9 6.34315 7.65685 5 6 5C4.34315 5 3 6.34315 3 8C3 9.65685 4.34315 11 6 11ZM9 21C11.2091 21 13 19.2091 13 17C13 14.7909 11.2091 13 9 13C6.79086 13 5 14.7909 5 17C5 19.2091 6.79086 21 9 21Z",
      fill: "#12131A",
      fillOpacity: "0.25"
    }), /*#__PURE__*/_jsx("path", {
      d: "M21 8C21 10.7614 18.7614 13 16 13C13.2386 13 11 10.7614 11 8C11 5.23858 13.2386 3 16 3C18.7614 3 21 5.23858 21 8Z",
      fill: "#12131A"
    })]
  }));
};

ChartBubbleIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export const DISABLED_POINT_STYLES = ['cross', 'crossRot', 'line', 'dash', 'star'];
export const defaultProps = {
  Scatter: {
    hasPointRadius: true,
    hasPointTemplate: false,
    chartType: 'scatter'
  },
  Bubble: {
    hasPointRadius: false,
    hasPointTemplate: true,
    chartType: 'bubble'
  }
};
export const defaultIcons = {
  Scatter: /*#__PURE__*/_jsx(ChartScatterIcon, {}),
  Bubble: /*#__PURE__*/_jsx(ChartBubbleIcon, {})
};